<template>
  <main class="not-found">
    <div class="not-found__content">
      <div class="not-found__code">404</div>
      <h1>Страница не найдена</h1>
      <p>Возможно, адрес введён с ошибкой или страница была перемещена.</p>
      <b-button variant="primary" :to="{ name: 'Homepage' }">На главную</b-button>
    </div>
  </main>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style lang="scss" scoped>
.not-found {
  display: grid;
  min-height: 100vh;
  padding: 32px;
  background: #f5f6f8;
  place-items: center;
}

.not-found__content {
  max-width: 560px;
  text-align: center;
}

.not-found__code {
  margin-bottom: 8px;
  color: #c80c0b;
  font-size: clamp(76px, 12vw, 140px);
  font-weight: 800;
  letter-spacing: -0.08em;
  line-height: 0.9;
}

h1 {
  margin-bottom: 12px;
  font-size: clamp(30px, 4vw, 44px);
  font-weight: 750;
}

p {
  margin-bottom: 28px;
  color: #667085;
  font-size: 17px;
}
</style>
